import { Layout, Typography } from "antd";
import { Outlet } from "react-router-dom";
import logo from "../../assets/ezygo-logo.png";
import "./AuthLayout.css";

const { Content } = Layout;
const { Text } = Typography;

export default function AuthLayout() {
  return (
    <Layout className="auth-layout">
      <Content className="auth-content">
        {/* LEFT SIDE: form area */}
        <div className="auth-left">
          <Outlet />
        </div>

        {/* RIGHT PANEL: brand */}
        <div className="auth-right">
          <div className="auth-brand">
            <img src={logo} alt="EZYGO" className="auth-logo" />
            <Text className="auth-subtitle">
              Manage Ezygo platform data
            </Text>
          </div>
        </div>
      </Content>
    </Layout>
  );
}